import React from 'react';
import {useTranslation} from 'react-i18next';
import {NavLink} from 'react-router-dom';
import {motion} from 'framer-motion';
import {sx} from './sx'
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import {SvgIconComponent} from '@mui/icons-material';
import {classNames} from "@helpers/classNames";
import {buildPathRootNavigateSingleVoyage} from "@containers/singleVoyage/navigate/rootNavigate/helpers/buildPath";
import {SV_SPRING} from "@containers/singleVoyage/views/constants/theme";

interface IProps {
    navigate: {
        label: string,
        path: string,
        icon?: SvgIconComponent,
    }
}

export const LAYOUT_ID_ACTIVE_NAV_SINGLE_VOYAGE = 'sv-root-nav-active'

const ItemNavigateSingleVoyage = ({navigate}: IProps) => {
    const {t} = useTranslation()
    const Icon = navigate.icon
    return (
        <Tooltip title={Icon ? t(navigate.label) : ''}>
        <NavLink
            to={buildPathRootNavigateSingleVoyage(navigate.path)}
            className={(props) => classNames(props.isActive && 'active')}
        >
            {({isActive}) => (
                <Box
                    component={'span'}
                    sx={Icon ? [sx.root, sx.iconRoot] : sx.root}
                    className={classNames(isActive && 'active')}
                >
                    {isActive && (
                        <Box
                            component={motion.span}
                            layoutId={LAYOUT_ID_ACTIVE_NAV_SINGLE_VOYAGE}
                            transition={SV_SPRING}
                            sx={sx.pill}
                        />
                    )}
                    <Box
                        component={'span'}
                        sx={sx.label}
                    >
                        {Icon ? <Icon sx={sx.icon}/> : t(navigate.label)}
                    </Box>
                </Box>
            )}
        </NavLink>
        </Tooltip>
    );
};

export default ItemNavigateSingleVoyage;
